export abstract class GeneratorUtility {
	public static generateId(): string {
		return '_' + Math.random().toString(36).substring(2, 9);
	}
}
